import React, { useState } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import styles from "./RegistrarCuenta.module.css";
import { useNavigate } from "react-router-dom";
import sideImage from "../../src/assets/img/login/sky-home.svg";
import logo from "../assets/img/logos/sky-new-2020-seeklogo2.svg";
import BarraLoader from "../General/BarraLoader";
import ConfirmMessage from "../General/ConfirmMessage";
import {
  CodeValidationRegistration_Request,
  builtCodeValidationRegistrationRequest,
  CodeValidationRegistration_Parametros,
  CodeValidationRegistration_Response,
} from "../Commons/Services/izzi/registro/CodeValidationRegistration";
import { ConsultaWS } from "../Commons/ServiciosBase";
import Loading from "../General/Loading";

export const RegistrarDobleFactor: React.FC = () => {
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [imagenURI] = useState(logo);

  const [loading, setLoading] = useState(false);

  const [numUno, setNumUno] = useState("");
  const [numDos, setNumDos] = useState("");
  const [numTres, setNumTres] = useState("");
  const [numCuatro, setNumCuatro] = useState("");

  const navigate = useNavigate();

  const handleChange2 = (index: number, value: string) => {
    console.log(value);
    if (value.length === 1) {
      if (/^[0-9]?$/.test(value)) {
        if (index === 1) {
          setNumUno(value);
          setFocusById("inputdos");
        } else if (index === 2) {
          setNumDos(value);
          setFocusById("inputtres");
        } else if (index === 3) {
          setNumTres(value);
          setFocusById("inputcuatro");
        } else if (index === 4) {
          setNumCuatro(value);
          setFocusById("buttonToSent");
        }
      }
    }
  };

  const setFocusById = (p_elementid: string) => {
    document.getElementById(p_elementid)!.focus();
  };

  const handleSubmit2FA = () => {
    setLoading(true);
    console.log("-------------------------------------------------");
    console.log(numUno);
    console.log(numDos);
    console.log(numTres);
    console.log(numCuatro);

    if (numUno !== "" && numDos !== "" && numTres !== "" && numCuatro !== "") {
      doCodeValidationRegistration();
    } else {
      setStatus("ERROR");
      setMessage("Favor de llenar las 4 casillas");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  };

  const doCodeValidationRegistration = async () => {
    //----------------------------------------------------------------------------------------------------------------------------
    let VerNum = numUno + "" + numDos + "" + numTres + "" + numCuatro;
    const CodeValidationRegistrationDO: CodeValidationRegistration_Request =
      builtCodeValidationRegistrationRequest(
        sessionStorage.getItem("cuenta2fa")!,
        VerNum
      );
    let CodeValidationRegistrationParametros =
      CodeValidationRegistration_Parametros(CodeValidationRegistrationDO, null);
    console.log("FFOP_______________________________________________");
    console.log(CodeValidationRegistrationParametros);
    let CodeValidationRegistratioResponse: CodeValidationRegistration_Response =
      await ConsultaWS(CodeValidationRegistrationParametros);
    console.log(CodeValidationRegistratioResponse);

    if (
      CodeValidationRegistratioResponse.code == "" &&
      CodeValidationRegistratioResponse.response.message === "OK"
    ) {
      redirect("/registroexitoso");
      //alert(CodeValidationRegistratioResponse);
    } else {
      console.error(CodeValidationRegistratioResponse);
      setStatus("ERROR");
      setMessage("Error al pre registrar la cuenta");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);

      redirect("/registroerroneo");
    }
    setLoading(false);
    //----------------------------------------------------------------------------------------------------------------------------
  };

  function redirect(url: string) {
    var ua = navigator.userAgent.toLowerCase(),
      isIE = ua.indexOf("msie") !== -1,
      version = parseInt(ua.substr(4, 2), 10);

    // Internet Explorer 8 and lower
    if (isIE && version < 9) {
      var link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
    }

    // All other browsers can use the standard window.location.href (they don't lose HTTP_REFERER like Internet Explorer 8 & lower does)
    else {
      window.location.href = url;
    }
  }
  //----------------------------------------------------------------------------------------------------------------------------
  const reenviarCodigo = async () => {
    setLoading(true);
    setMessage("");

    try {
      const cuenta2fa = sessionStorage.getItem("cuenta2fa");
      if (!cuenta2fa) {
        setMessage("Error: No se encontró la cuenta asociada.");
        setLoading(false);
        return;
      }

      const response = await fetch(
        `https://qamiespaciosky.sky.com.mx:7000/mi-sky-api/izzi/registro/reenviar-codigo/${cuenta2fa}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ cuenta: cuenta2fa }),
        }
      );
      const data = await response.json();

      if (response.ok) {
        setMessage("Código reenviado con éxito. Revisa tu correo o teléfono.");
      } else {
        setMessage(
          `Error: ${data.message || "No se pudo reenviar el código."}`
        );
      }
    } catch (error) {
      setMessage("Error al comunicarse con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container className={styles.container}>
        <div className={styles["confirmMessage"]}>
          <ConfirmMessage
            status={status}
            message={message}
            showAlert={showAlert}
          />
        </div>

        <Loading isLoading={loading} />

        <Row className={styles["rowContainer"]}>
          <Col
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
            className={styles["registrarForm"]}
          >
            <Form className={styles.estiloForm}>
              <img src={imagenURI} className={styles.logo} alt="Logo" />
              <hr className={styles["line"]} />

              <Row>
                <h4
                  className={
                    "text-2xl text-center " + styles["textGradient"] + " mb-2"
                  }
                >
                  <span>Registro</span>
                </h4>
              </Row>

              {/* Código de verificación */}
              <Row className="justify-content-center">
                <Col md={12} className="text-center">
                  <p>
                    Hemos enviado un código al número{" "}
                    {`${sessionStorage.getItem("phoneNumberTOS")} y al correo ${sessionStorage.getItem("emailTOS")}`}
                  </p>
                  <p>Ingresa código de verificación</p>
                  <Form className={styles.form}>
                    <div className={styles.codeInputContainer}>
                      <input
                        key={"index1"}
                        id="inputuno"
                        type="text"
                        maxLength={1}
                        value={numUno}
                        onChange={(e) => handleChange2(1, e.target.value)}
                        className={styles.codeInput}
                      />
                      <input
                        key={"index2"}
                        id="inputdos"
                        type="text"
                        maxLength={1}
                        value={numDos}
                        onChange={(e) => handleChange2(2, e.target.value)}
                        className={styles.codeInput}
                      />
                      <input
                        key={"index3"}
                        id="inputtres"
                        type="text"
                        maxLength={1}
                        value={numTres}
                        onChange={(e) => handleChange2(3, e.target.value)}
                        className={styles.codeInput}
                      />
                      <input
                        key={"index4"}
                        id="inputcuatro"
                        type="text"
                        maxLength={1}
                        value={numCuatro}
                        onChange={(e) => handleChange2(4, e.target.value)}
                        className={styles.codeInput}
                      />
                    </div>
                  </Form>
                </Col>
              </Row>

              <Row>
                <Col className={styles["buttonContainer"]}>
                  <Button
                    variant="btn btn-primary"
                    className={styles.boton}
                    onClick={handleSubmit2FA}
                    id="buttonToSent"
                  >
                    Validar cuenta
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col className="center text-center">
                  <span className="center">¿No recibiste el código?</span>{" "}
                  <a onClick={reenviarCodigo} className={styles["login"]}>
                    <span className="text-end">Reenviar</span>
                  </a>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            className={styles["imageContainer"]}
          >
            <img src={sideImage} className={styles["sideImage"]} alt="Side" />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RegistrarDobleFactor;
